'use strict';

$.widget('fotobook.calendarProjectStartDate', $.fotobook.monthpicker, {
    _create() {
        this._super();
        this.createLayout();
    },

    _tpl: [
        '<div class="month-selection-block ajax-tooltip" data-qtip-text="', t('photobook-calendar-date').escapeAttr(), '">',
        '<input type="text" class="monthpicker-selection-input" value="">',
        '</div>',
    ].join(''),

    createLayout() {
        const $this = this;
        this.layoutBlock = $(this._tpl);
        this.element.append(this.layoutBlock);
        this.monthpicker = $('.monthpicker-selection-input');

        this.monthpicker.MonthPicker($.extend($this.options, {
            OnAfterChooseMonth() {
                $this.change($(this).val());
            },
        }));
    },

    change(date) {
        this.disable();
        Fotobook.ajax.postJSON('/calendar/project-dates/set-start', {
            data: {
                date: new Date(date).toDateString(),
            },
        }).then((response) => {
            Fotobook.isModified = true;
            Fotobook.book.updateBookFromResponse(response.data);
        }).finally(() => {
            this.enable();
        });
    },

    _destroy() {
        this._super();
        this.layoutBlock.remove();
    },
});
